import BaseModule from "~/vuex/modules/base-module";

let Enquiries = {...BaseModule};

Enquiries.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/enquiries';

    state.lastDate = null;
    state.sort = {};


    return state;
};



export default Enquiries;